import React from 'react';

import { Link } from '~/lib/react-router-dom';

import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Stack } from '@mui/material';
import { GridDeleteIcon } from '@mui/x-data-grid';

import ConfirmButton from '~/components/Common/Elements/ConfirmButton';

interface Props {
  row: App.FlightDeal;
  onDelete: (id: string) => void;
}

export function FlightDealsTableActionButtons({ row, onDelete }: Props) {
  return (
    <Stack direction="row" alignItems="center" gap={1} height="100%">
      <IconButton
        component={Link}
        to={`/flights/flight-deal/${row.id}/edit`}
        size="small"
        color="primary"
        aria-label="Edit deal"
      >
        <EditIcon />
      </IconButton>

      <ConfirmButton
        confirmTitle="Delete deal"
        confirmQuestion="Are you sure you want to delete this deal?"
        confirmAnswer="Yes, delete"
        onConfirm={() => onDelete(row.id)}
        color="error"
        variant="outlined"
        size="small"
        aria-label="Delete deal"
      >
        <GridDeleteIcon />
      </ConfirmButton>
    </Stack>
  );
}
